import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fa0431f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "c_logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "black" }
const _hoisted_8 = { class: "gray" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "leaf",
  src: "/assets/icon/small_leaf.png"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divide" }, " | ", -1))
const _hoisted_11 = { class: "gray" }
const _hoisted_12 = { class: "board_info space-between" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "green score" }
const _hoisted_15 = { class: "gray" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 0,
  class: "star",
  src: "/assets/icon/like_btn.png",
  srcset: "/assets/icon/like_btn@2x.png 2x,/assets/icon/like_btn@3x.png 3x"
}
const _hoisted_18 = {
  key: 1,
  src: "/assets/icon/like_btn_e.png",
  srcset: "/assets/icon/like_btn_e@2x.png 2x,/assets/icon/like_btn_e@3x.png 3x"
}
const _hoisted_19 = { class: "board_content" }
const _hoisted_20 = ["onClick", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_star_rating_inline = _resolveComponent("star-rating-inline")!
  const _component_print_og_data = _resolveComponent("print-og-data")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItemBoards, (board) => {
      return (_openBlock(), _createElementBlock("div", {
        key: board.stockItemBoardId,
        class: "board_list"
      }, [
        _createElementVNode("div", {
          class: "ion-activatable ripple-parent logo-title",
          onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`${board.stockItemName}`});_ctx.useCompanyModal(board.stockItemId, 'community')}
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: board.companyLogo ? board.companyLogo : '/assets/icon/company_default_img.png',
              onerror: "this.src='/assets/icon/company_default_img.png'",
              class: "img-responsive img-circle"
            }, null, 8, _hoisted_3),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(board.stockItemName), 1),
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ], 8, _hoisted_1),
        _createElementVNode("div", {
          class: "ion-activatable ripple-parent board_top",
          onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`${board.stockItemName}`});_ctx.useCompanyModal(board.stockItemId, 'community')}
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(board.email), 1),
          _createElementVNode("span", _hoisted_8, [
            _createTextVNode("의견 " + _toDisplayString(board.count) + " · 평균 ", 1),
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(_ctx.toFixed(+board.avgPoint, 1)), 1)
          ]),
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(board.joinCount) + "개 조합 참여", 1),
          _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
        ], 8, _hoisted_6),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent board_left",
            onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`${board.stockItemName}`});_ctx.useCompanyModal(board.stockItemId, 'community')}
          }, [
            _createVNode(_component_star_rating_inline, {
              class: "inline",
              value: board.point
            }, null, 8, ["value"]),
            _createElementVNode("span", _hoisted_14, _toDisplayString(board.point), 1),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.prettyDateToOnemonth(board.updateAt)), 1),
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ], 8, _hoisted_13),
          _createElementVNode("div", {
            class: "ion-activatable ripple-parent board_right",
            onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`좋아요버튼`});(_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.boardLike(board))}
          }, [
            (board.likeFlag === true)
              ? (_openBlock(), _createElementBlock("img", _hoisted_17))
              : (_openBlock(), _createElementBlock("img", _hoisted_18)),
            _createElementVNode("span", {
              class: _normalizeClass({'deep-blue': board.likeFlag, 'grey': !board.likeFlag})
            }, _toDisplayString(board.likeCount), 3),
            _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
          ], 8, _hoisted_16)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", {
            class: _normalizeClass({gray:(board.status!='show')}),
            onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`게시글`});_ctx.boardClick(board,$event)},
            innerHTML: _ctx.printContent(board.contents, true)
          }, null, 10, _hoisted_20),
          (board.ogData)
            ? (_openBlock(), _createBlock(_component_print_og_data, {
                key: 0,
                og: board.ogData,
                onClickCapture: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'토론 NOW', 'clickContent':`링크미리보기`});_ctx.openLink(board.ogData.url)}
              }, null, 8, ["og", "onClickCapture"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(_component_ion_infinite_scroll, {
      id: "infinite-scroll",
      threshold: "100px",
      disabled: !_ctx.hasMore,
      onIonInfinite: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadData($event)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_infinite_scroll_content, { "loading-spinner": "bubbles" })
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}